module.exports = __webpack_public_path__ + "static/img/2.273e9b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/2.png
// module id = Da1Z
// module chunks = 0